export default __webpack_public_path__ + "static/media/obras.1e6c201c.jpg";